import $ from 'jquery';
import { cartDrawerOpenRequestEventType } from '../../core/notifications/cart-drawer-open-request';
import { freeze, thaw } from './freeze-body-scrolling';
import { initOffcanvasMachine, DrawerName } from './machine';
import { updateElementTabIndex } from '../a11y-utils';
import { createFocusTrap } from 'focus-trap';
/**
 * @description Activate offcanvas drawers
 */ export const init = async function(cart) {
    const machine = initOffcanvasMachine();
    globalThis.__offcanvasMachine = machine;
    const allDrawers = $('.js-offcanvas') // Main drawers like cart, gift, menu.
    ;
    const megaMenus = $('.js-mobile-megamenu') // Menu submenus. They are not part of the offcanvas machine.
    ;
    const megaMenusFocusTraps = {};
    const initializeDrawers = ()=>{
        if (allDrawers.length === 0) {
            return;
        }
        allDrawers.each(function() {
            const rawElement = $(this).get(0);
            // When initialized, all the tabbable elements in the drawers must be set to tabindex -1
            // so they are not tabbable when a drawer is collapsed.
            // The drawer tabbable elements will be set to regular tabindex from the machine
            // when the drawer will be expanded.
            if (rawElement) {
                updateElementTabIndex(rawElement, false);
            }
        });
        // Initialize focus traps for mega menus.
        // Mega menus are not part of the offcanvas machine, but they need to be focus trapped.
        megaMenus.each(function() {
            const rawElement = $(this).get(0);
            if (rawElement) {
                const drawerName = rawElement.getAttribute('data-megamenu-name');
                if (drawerName) {
                    megaMenusFocusTraps[drawerName] = createFocusTrap(rawElement, {
                        escapeDeactivates: false,
                        clickOutsideDeactivates: true,
                        initialFocus: rawElement,
                        fallbackFocus: rawElement
                    });
                }
            }
        });
        machine.subscribe(function toggleDrawer({ value: state , context: { drawerName  }  }) {
            if (state === 'collapsed') {
                megaMenus.removeClass('is-expanded');
                thaw('has-open-offcanvas');
                return;
            }
            const attrFilter = `[data-drawer-names~='${drawerName}']`;
            freeze('has-open-offcanvas');
            allDrawers.filter(attrFilter).addClass('is-expanded');
            allDrawers.not(attrFilter).removeClass('is-expanded');
        });
        machine.start();
        init.__offcanvasMachine = machine;
        const handleMenuHide = ()=>{
            // immediately hide the megamenus before the drawer collapse animation,
            // then restore them after the drawer collapse animation
            megaMenus.hide();
            setTimeout(()=>{
                machine.send({
                    drawerName: 'menu',
                    type: 'collapse'
                });
                megaMenus.show();
            }, 50);
        };
        $('#js-offcanvas-bg').on('click', function() {
            machine.send({
                type: 'collapse'
            });
            const searchButton = $('.js-offcanvas-trigger[data-drawer-name="search"]');
            searchButton.removeClass('hide');
            $('.js-search-hide[data-drawer-name="search"]').addClass('hide');
            searchButton.attr('aria-expanded', 'false');
            const menuButton = $('.js-offcanvas-trigger[data-drawer-name="menu"]');
            $('[data-megamenu-name]').removeClass('is-expanded');
            menuButton.attr('aria-expanded', 'false');
        });
        $('.js-search-hide').on('click', function() {
            // hide search cart, hide close icon and show search icon
            $('.js-offcanvas-trigger[data-drawer-name="search"]').toggleClass('hide');
            $('.js-search-hide[data-drawer-name="search"]').toggleClass('hide');
            machine.send({
                type: 'collapse'
            });
        });
        // hide the main menu drawer
        $('.js-menu-hide').on('click', function() {
            handleMenuHide();
        });
        $(document).on('click', '.js-offcanvas-close', function(evt) {
            evt.preventDefault();
            const drawerName = $(evt.currentTarget).attr('data-drawer-name') || '';
            if (DrawerName.is(drawerName)) {
                if (drawerName === 'menu') {
                    const openButton = $('.js-offcanvas-trigger[data-drawer-name="menu"]');
                    openButton.attr('aria-expanded', 'false');
                    const drawer = $('.Offcanvas[data-drawer-names="menu"]');
                    drawer.attr('aria-hidden', 'true');
                }
                machine.send({
                    drawerName,
                    type: 'collapse'
                });
            }
        });
        $('.js-offcanvas-trigger').on('click', function(evt) {
            evt.preventDefault();
            const drawerName = $(evt.delegateTarget).attr('data-drawer-name') || '';
            if (DrawerName.is(drawerName)) {
                if (drawerName === 'menu') {
                    const openButton = $('.js-offcanvas-trigger[data-drawer-name="menu"]');
                    openButton.attr('aria-expanded', 'true');
                    const drawer = $('.js-offcanvas[data-drawer-names="menu"]');
                    drawer.attr('aria-hidden', 'false');
                }
                machine.send({
                    type: 'expand',
                    drawerName
                });
            }
        });
        $('.js-mobile-submenu-open').on('click', function(evt) {
            evt.preventDefault();
            const drawerName = $(evt.delegateTarget).attr('data-megamenu-name');
            const openButton = $(evt.delegateTarget);
            openButton.attr('aria-expanded', 'true');
            if (drawerName) {
                const drawer = $('.js-mobile-megamenu[data-megamenu-name="' + drawerName + '"]');
                const drawerElement = drawer.get(0);
                if (drawerElement) {
                    updateElementTabIndex(drawerElement, true);
                    if (megaMenusFocusTraps[drawerName]) {
                        var _megaMenusFocusTraps_drawerName;
                        (_megaMenusFocusTraps_drawerName = megaMenusFocusTraps[drawerName]) === null || _megaMenusFocusTraps_drawerName === void 0 ? void 0 : _megaMenusFocusTraps_drawerName.activate();
                    }
                    drawer.addClass('is-expanded');
                }
            }
        });
        $('.js-mobile-megamenu-back').on('click', function(evt) {
            evt.preventDefault();
            const drawerName = $(evt.delegateTarget).attr('data-megamenu-close') || '';
            const submenuOpenButton = $(`.js-mobile-submenu-open[aria-controls="${drawerName}"]`);
            submenuOpenButton.attr('aria-expanded', 'false');
            const drawer = $(`.js-mobile-megamenu[data-megamenu-name="${drawerName}"]`);
            const drawerElement = drawer.get(0);
            if (drawerElement) {
                if (megaMenusFocusTraps[drawerName]) {
                    var _megaMenusFocusTraps_drawerName;
                    (_megaMenusFocusTraps_drawerName = megaMenusFocusTraps[drawerName]) === null || _megaMenusFocusTraps_drawerName === void 0 ? void 0 : _megaMenusFocusTraps_drawerName.deactivate();
                }
                updateElementTabIndex(drawerElement, false);
                drawer.removeClass('is-expanded');
            }
        });
        $(document).on(cartDrawerOpenRequestEventType, function() {
            machine.send({
                type: 'collapse',
                drawerName: 'gift'
            });
            machine.send({
                type: 'expand',
                drawerName: 'cart'
            });
        });
        $(document).on('click', '#js-ajaxupsell-btn', ()=>{
            $('.js-size-guide-close').click();
            const selectedVariantId = $('.js-upsell-price.active').attr('variant_id') || '';
            if (selectedVariantId !== '') {
                const data = {
                    id: selectedVariantId,
                    quantity: 1
                };
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    async: false,
                    complete: function() {
                        const cartNumber = parseInt($('.js-cart-item-count').attr('data-item-count') || '0') + 1;
                        if (cartNumber > 0) {
                            $('.js-cart-item-count').attr('data-item-count', cartNumber);
                        } else {
                            $('.js-cart-item-count').attr('data-item-count', '');
                        }
                    }
                }).promise().done(()=>{
                    machine.send({
                        type: 'expand',
                        drawerName: 'cart'
                    });
                });
            }
        });
        $(document).on('click', '.js-offcanvas-trigger-gift', ()=>{
            machine.send({
                type: 'collapse',
                drawerName: 'cart'
            });
            machine.send({
                type: 'expand',
                drawerName: 'gift'
            });
        });
        $(document).on('click', '.js-offcanvas-close-gift', ()=>{
            machine.send({
                type: 'collapse',
                drawerName: 'gift'
            });
            if (window.location.href.includes('cart')) {
                return;
            }
            machine.send({
                type: 'expand',
                drawerName: 'cart'
            });
        });
        // Collapse the drawer when the window width enters the desktop range
        $(window).on('resize', ()=>{
            const windowWidth = $(window).width();
            if (typeof windowWidth !== 'undefined' && windowWidth > 1024) {
                handleMenuHide();
            }
        });
        $(document).on('keydown', (evt)=>{
            if (evt.key === 'Escape') {
                handleMenuHide();
            }
        });
    };
    initializeDrawers();
    // we need to observe changes on the cart for elements added or removed
    // to set their tabindex
    const targetNode = document.querySelector('.js-offcanvas[data-drawer-names="cart"]');
    if (targetNode) {
        const callback = function(mutationsList) {
            for (const mutation of mutationsList){
                if (mutation.type === 'childList') {
                    if (targetNode instanceof HTMLElement) {
                        updateElementTabIndex(targetNode, true);
                    }
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, {
            childList: true,
            subtree: true
        });
    }
};
